import React from 'react'
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { BottomNavigation, Box, Link, useMediaQuery } from '@mui/material';
import './Footer.css'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DangerousIcon from '@mui/icons-material/Dangerous';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';


const Footer = () => {

  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  const navigate = useNavigate()

  const mobile = () => (
    <div id="footer">
      <p>
      Do you have a problem | <Link style={{color:"#fff", textDecoration: 'underline'}} onClick={() => navigate('/contact')}>Contact Us</Link>
      </p>
      <p>
       Privacy Policy |   <Link sx={{color:"#fff", textDecoration: 'underline'}} className="link" onClick={() => navigate('/privacy')}>Privacy and policy terms</Link>
      </p>
   
    <div>
      <p>Phone Number: +40789989989</p>
        <ul className="availableHoursList">
          <li className="listItem"><AccessTimeIcon className="programIcon"/>Monday-Friday: 10:00 - 18:00</li>
          <li className="listItem"><AccessTimeIcon className="programIcon"/>Saturday: 12:00 - 16:00</li>
          <li className="listItem"><DangerousIcon className="programIcon"/>Sunday: free</li>
        </ul>
    </div>
    <div id="socialMedia">
      <div>
        <a  className="icon iconFirst" style={{color: 'inherit'}} href="https://www.instagram.com/vlad_alex19/" rel="noreferrer" alt="instagram link" target="_blank">
            <InstagramIcon className="icon" fontSize="large"></InstagramIcon>
        </a>
        <a  style={{color: 'inherit'}} href="https://www.facebook.com/vladalexx19/" rel="noreferrer" alt="instagram link" target="_blank">
            <FacebookIcon fontSize="large" className="icon"></FacebookIcon>
        </a>
      </div>
      <p id="copyrightMessage">Copyright Vlad Web 2k23</p>
    </div> 
    </div>
  )

  const tablet = () => (
    <BottomNavigation>
    <div id="socialMedia">
      <div>
        <a  className="icon iconFirst" style={{color: 'inherit'}} href="https://www.instagram.com/vlad_alex19/" rel="noreferrer" alt="instagram link" target="_blank">
            <InstagramIcon className="icon" fontSize="large"></InstagramIcon>
        </a>
        <a  style={{color: 'inherit'}} href="https://www.facebook.com/vladalexx19/" rel="noreferrer" alt="instagram link" target="_blank">
            <FacebookIcon fontSize="large" className="icon"></FacebookIcon>
        </a>
      </div>
      <p id="copyrightMessage">Copyright Vlad Web 2k23</p>
    </div> 
    <div>
      <p>Phone Number: +40789989989</p>
      Contact Hours
        <ul className="availableHoursList">
          <li className="listItem"><AccessTimeIcon className="programIcon"/>Monday-Friday: 10:00 - 18:00</li>
          <li className="listItem"><AccessTimeIcon className="programIcon"/>Saturday: 12:00 - 16:00</li>
          <li className="listItem"><DangerousIcon className="programIcon"/>Sunday: free</li>
        </ul>
    </div>
    </BottomNavigation>
  )
  const desktop = () => (
    <BottomNavigation sx={{backgroundColor:'#93032E', height:'220px', marginTop:'150px', color: "#fff"}}>
      <Box style={{width:'1200px', margin: '0 auto',display:'flex', justifyContent:'space-between'}}>
        <Box>
          <Box>
            <h3>Follow us</h3>
            <Link style={{color: 'inherit'}} href="https://www.instagram.com/vlad_alex19/" rel="noreferrer" alt="instagram link" target="_blank">
                <InstagramIcon className="icon" fontSize="large"></InstagramIcon>
            </Link>
            <Link style={{color: 'inherit'}} href="https://www.facebook.com/vladalexx19/" rel="noreferrer" alt="instagram link" target="_blank">
                <FacebookIcon className="icon" fontSize="large"></FacebookIcon>
            </Link>
          </Box>
        </Box> 
        <Box sx={{display:'flex', flexDirection:'column'}}>
          <h3>Support and legal info</h3>
          <Link sx={{color:"#fff", textDecoration:'underline'}} className="link" to="/privacy" onClick={() => navigate('/privacy')}>Privacy and policy terms</Link>
        </Box>

        <Box sx={{display:'flex', flexDirection:'column'}}>
          <h3>Contact</h3>
          <Link className="link" sx={{color:"#fff", textDecoration: 'underline'}} onClick={() => navigate('/contact')}>Contact Us</Link>
        </Box>
      

        <Box>
          <h3>Contact</h3>
          <p>Phone Number: +40789989989</p>
            <ul className="availableHoursList">
              <li className="listItem"><AccessTimeIcon className="programIcon"/>Monday-Friday: 10:00 - 18:00</li>
              <li className="listItem"><AccessTimeIcon className="programIcon"/>Saturday: 12:00 - 16:00</li>
              <li className="listItem"><DangerousIcon className="programIcon"/>Sunday: free</li>
            </ul>
        </Box>
      </Box>
    </BottomNavigation>
  )

  return (
    <div>
     {
      (isXs) ?  mobile() : 
      (isSm) ? mobile() :
      (isMd) ? tablet() :
      desktop()
     }
    </div>
  )
}

export default Footer